export enum CONFIG_TAG_TYPE {
    pinningGames = 'pinning_games',
    componentAppearanceSettings = 'component_appearance_settings',
    atpSettings = 'atp_settings',
    occupationConfig = 'occupation_config',
    joinNowConfig = 'join_now_config',
    loginInfoConfig = 'login_info_config',
    futureAnthemsConfig = 'future_anthems_config',
    footerLinkConfig = 'footer_link_config',
    buyaPowaConfig = 'buya_powa_config',
    retailPagesConfig = 'retail_pages',
}

export enum TAG_TYPE_BUZZ {
    parcelPromotion = 'parcel_promotion_tag',
    bottomNavigation = 'bottom_navigation',
    backToTopButton = 'back_to_top_button',
    topNavigation = 'top_navigation',
    atpSettings = 'atp_settings',
    occupationConfig = 'occupation_config',
    futureAnthemsConfig = 'future_anthems_config',
    footerLinkConfig = 'footer_link_config',
    buyaPowaConfig = 'buya_powa_config',
}

export enum CONDITION_TYPE_BUZZ {
    excludePage = 'exclude_page_condition'
}

export enum PLATFORM {
    Mobile = 'Mobile',
    Tablet = 'Tablet',
    Desktop = 'Desktop'
}

export enum FILL_TYPE {
    gradient = 'gradient',
    solid = 'solid'
}
